import { render, staticRenderFns } from "./kdbtt.vue?vue&type=template&id=202ff12c&"
import script from "./kdbtt.vue?vue&type=script&lang=js&"
export * from "./kdbtt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports